module.exports = __webpack_public_path__ + "media/images/gallery/en_tab_off-d3a6558fa40b9d0df0fbaa9849053a36.jpg";